import { type JSX } from 'react';
import { VOICE_PAGE_WRAPPER_ID } from '../../common/constants/subscriptionConstants';
import { ModelType } from '../../common/enums.js';
import { AnalyticsEventOrigins } from '../../common/utils/analyticsUtils';
import { SubscriptionCardsByModelTypeWrapper } from '../OrderSubscriptionSelection/SubscriptionCardsByModelTypeWrapper.js';
import { PublicMobileVoiceBreadcrumbs } from './PublicMobileVoiceBreadcrumbs';
import { PublicMobileVoiceFeatureHighlights } from './PublicMobileVoiceFeatureHighlights';
import { PublicMobileVoiceHeader } from './PublicMobileVoiceHeader';
import { PublicMobileVoiceSubscriptionsAdditionalComponents } from './PublicMobileVoiceSubscriptionsAdditionalComponents';

import './PublicMobileVoiceSubscriptions.scss';

export const PublicMobileVoiceSubscriptions = (): JSX.Element => (
  <section className="of-public-mobile-voice-subscriptions of-public-page" id={VOICE_PAGE_WRAPPER_ID}>
    <PublicMobileVoiceBreadcrumbs />
    <PublicMobileVoiceHeader />
    <PublicMobileVoiceFeatureHighlights />
    <SubscriptionCardsByModelTypeWrapper
      onlineModelType={ModelType.YrityspuheUusi}
      eventOrigin={AnalyticsEventOrigins.PUBLIC}
    />
    <PublicMobileVoiceSubscriptionsAdditionalComponents />
  </section>
);
